import { make } from 'vuex-pathify'

const state = {
    uva: '',
    eddi: null,
    years: [],
    loading: false,
    invalidUva: false,
}

const getters = {
    search(state) {
        if (! state.uva) {
            return
        }

        state.loading = true

        window.axios.get('/api/eddi/'+ state.uva).then(response => {
            if(response.data.data.length > 0) {
                state.eddi = response.data.data[0]
                state.years = response.data.data.reduce((acc, current) => {
                    acc.push(current.year.year)
                    return acc
                }, []).sort()
            }

            state.loading = false

            if(! state.eddi) {
                state.invalidUva = true
            }
            else {
                state.invalidUva = state.eddi.uva !== state.uva
            }
        })
    },
    hasErrors(state) {
        return state.eddi.year === null
            || state.eddi.department === null
            || state.eddi.programme === null
    },
    showResults(state) {
        if (! state.eddi) {
            return false
        }

        return ! state.invalidUva && ! state.loading
    }
}

const mutations = {
    ...make.mutations(state),
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}